import {getConfigFields, getMaxLengthConstraint, getNotNullConstraint, getPatternConstraint} from '../fields.js'
import {formFieldIds, PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL} from '../values.js'

const {kilometersId, plate, vehicleStatus} = formFieldIds

// web_seller_instant_offer_landing_test
const instantOfferLandingPlateFieldsConfig = [
  getConfigFields[plate](),
  getConfigFields[kilometersId]({
    customProps: {
      constraints: [
        getNotNullConstraint({
          message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.NOTNULL'
        }),
        getMaxLengthConstraint({
          value: 7
        }),
        getPatternConstraint({
          message: 'PUBLISH_AD.FB.KMS.CONSTRAINTS.MIN',
          pattern: PATTERN_CONSTRAINT_MIN_KILOMETERS_FOR_A_VALID_C2B_APPRAISAL
        })
      ],
      hint: 'COMMON.KMS_VEHICLE_VARIANT',
      label: 'COMMON.KMS'
    }
  }),
  getConfigFields[vehicleStatus]()
]

export const instantOfferLandingPlateFormConfig = {
  fields: instantOfferLandingPlateFieldsConfig
}
